import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';
import { StopChargingRequest } from '../../interface/charging-session.interface';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch devices API
   * @param query
   */
  fetchDevices: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-transaction/list-all-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Stop Charging API
   * @param data
   */
  stopCharging: (data: StopChargingRequest): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/facility/remote-stop-transaction`, data);
  },

  /**
   * Fetch charging session API
   * @returns 
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/charging-transaction/list-filters`);
  },
};
